module.exports = __webpack_public_path__ + "img/more.2ffeb650.png";